import React, {Component} from 'react';
import {Router, Switch} from "react-router";
import {route} from "./route";
import appHistory from "./appHistory";
import {Subject} from "rxjs";


let appRouter: any = null;

let globalUpdateSubject = new Subject();

export const onGlobalUpdate = (cb?: any) => {
    return globalUpdateSubject.subscribe(cb);
}

export const globalUpdate = (cb?: any) => {
    globalUpdateSubject.next();
}

export const realGlobalUpdate = (cb?: any) => {
    if (appRouter) appRouter.forceUpdate(cb)
}


class AppRouter extends Component<any, any> {

    constructor(props: Readonly<any>) {
        super(props);
        appRouter = this;
    }

    render() {
        return (
            <>
                <Router history={appHistory}>
                    <Switch>
                        {route(process.env.PUBLIC_URL + "/login", import("../views/auth/Login"))}
                        {route("*", import('../views/App'))}
                    </Switch>
                </Router>
            </>
        );
    }
}


export default AppRouter;
